export default function Footer() {
  const ano = new Date().getFullYear();
  return (
    <footer className="text-center text-secondary py-4 mt-auto" role="contentinfo">
      <small>
        © {ano}{' '}
        <a href="https://portfolio.mathee.us" target="_blank" rel="noreferrer">
          Matheus de Lima Ramos
        </a>
      </small>
    </footer>
  );
}
